import { format, isSameDay } from 'date-fns';
import { locale } from '../config/language.config';
import apiInstance from '../lib/api/api.instance';
/* return current SSOUser's username/email
 * Loop logic, attempt to call `authenticate` upto 5 retries before throwing the user to the error page
 * when response is 401 as per ticket TID-903.
 */
export const getSSOUser = async () => {
    return await apiInstance
        .get(`authenticate`, {
        xsrfHeaderName: 'X-XSRF-TOKEN', // default
        xsrfCookieName: 'XSRF-TOKEN',
        withCredentials: true,
        // `undefined` (default) - set XSRF header only for the same origin requests
        withXSRFToken: true,
    })
        .then((response) => {
        return response.data;
    })
        .catch((err) => {
        console.error('error found !!!', err);
        // DONT change the redirect URL to logoutUrl(routes.config.tsx) as it wont work on local
        const redirectUrl = process.env.BASE_URL + '/oauth2/authorization/b2c_1a_signup_signin';
        // check if app opened by sso portal
        console.log('document.referrer:', document.referrer);
        const isFromSSOPortal = document.referrer === process.env.SSO_SITE_URL;
        // handle CORS error
        if (typeof err.response === 'undefined') {
            console.log('call oauth endpoint');
            // hit the backend endpoint to trigger oidc flow, after user login again user will back to current site
            logout();
            window.location.href = redirectUrl + (isFromSSOPortal ? '?fromSSOPortal=true' : '');
        }
        // if there is any 403 (or add others) error then return back to qa sso site
        if (typeof err.response !== 'undefined') {
            switch (err.response.status) {
                case 401:
                    //window.location.href = 'https://login-qa.moneris.com';
                    window.location.href = redirectUrl + (isFromSSOPortal ? '?fromSSOPortal=true' : '');
                    throw new Error('401-Reauthenticate');
                default:
                    throw err;
            }
        }
    });
};
// Api request for getting merchant onboarding status
const getUserMerchantList = async () => {
    const response = await apiInstance.post(`userMerchant/getInfoList`);
    return response?.data;
};
// API request to set user's login date for the logged in merchant number
export const postTrackUserMerchantLogin = async (merchantNumber) => {
    const merchantNumberString = String(merchantNumber);
    // Default to empty object if localStorage is empty
    const loginStorage = JSON.parse(localStorage.getItem('idi-merchant-login')) ?? {};
    const currentDate = format(new Date(), 'yyyy-MM-dd');
    // Get timestamp from storage
    const lastMerchantLogin = loginStorage[merchantNumberString];
    if (lastMerchantLogin === undefined ||
        isSameDay(new Date(currentDate), new Date(lastMerchantLogin)) === false) {
        // if not in storage, add to storage
        // if the date is not the same, update the date
        loginStorage[merchantNumberString] = currentDate;
        localStorage.setItem('idi-merchant-login', JSON.stringify(loginStorage));
        apiInstance
            .post('/userMerchant/lastLogin', {
            merchantNumber,
        })
            .catch((err) => {
            console.error('Error setting last login date:', err);
        });
    }
};
export const logout = () => {
    return apiInstance
        .get('logout', {
        withXSRFToken: true,
    })
        .then((response) => {
        return response?.data;
    })
        .catch((err) => {
        console.error(err);
    });
};
// List of merchant information from MD2
export const getMerchantInfoList = () => {
    return apiInstance.post('/user/merchantInfoList').then((response) => {
        return response?.data;
    });
};
export const getSelfServeMerchantList = (merchantList) => {
    const merchantNumbers = merchantList.map((merchant) => merchant.number);
    return apiInstance
        .post('/userMerchant/profile', {
        merchantNumbers: merchantNumbers,
    })
        .then((response) => {
        return response?.data?.merchantList?.merchants;
    });
};
export const getToken = async () => {
    const response = await apiInstance.get('/token');
    return response?.data;
};
export const getBusinessInfo = (merchantNumber) => {
    return apiInstance
        .post('/userMerchant/businessInfo', {
        merchantNumber: merchantNumber,
    })
        .then((response) => {
        return response?.data;
    });
};
/*const DEFAULT_MD2_MERCHANT = {
  businessAddress: '100 WEST DUMMY STREET WEST, TORONTO, ON M5N2W5',
  addressComponent: {
    line_1: '100 WEST DUMMY STREET',
    line_2: 'WEST',
    line_3: '',
    country_code: 'CAN ',
    city: 'TORONTO',
    province_code: 'ON',
    postal_code: 'M5N2W5',
  },
  postalCode: 'M5N2W5',
  businessType: null,
  businessSubtype: null,
};*/
// Inner join Insights merchants and MD2 merchants under User account
export const getMerchantInfo = async () => {
    return await Promise.all([getUserMerchantList(), getMerchantInfoList()]).then((values) => {
        const [merchantList, md2MerchantData] = values;
        if (md2MerchantData === undefined) {
            return [];
        }
        return (md2MerchantData.reduce((list, merchant) => {
            // inner join merchants
            const match = merchantList.find((o) => o.merchantNumber == merchant.merchantNumber);
            if (match) {
                const { notifOnboardingStatus, productOnboardingStatus, notifLanguage, preferredName } = match || {};
                list.push({
                    number: merchant.merchantNumber,
                    ...merchant,
                    ...match,
                    notifOnboardingStatus: notifOnboardingStatus || 0,
                    productOnboardingStatus: productOnboardingStatus || 0,
                    notifLanguage: notifLanguage || locale.en,
                    preferredName: preferredName || 'Merchant',
                });
            }
            return list;
        }, []) || []);
    });
};
